<template>
  <div class="flex flex-col bg-gray-100 items-start p-1 gap-1">
    <div class="flex flex-row gap-3">
      <div class="font-bold">
        {{ buildingTypeDisplay }}
      </div>
      <span>{{ buildingData?.name }}</span>
    </div>
    <div class="flex flex-row gap-3">
      <HighlightChange
        :changeType="buildingAddressDiff">
        <AddressDisplay
          :smallFont="true"
          :addressData="buildingData?.address"
        />
      </HighlightChange>
    </div>
  </div>
</template> 

<script>
import AddressDisplay from './AddressDisplay.vue'

import HighlightChange from '../utilities/HighlightChange.vue'

import scheduleUtil from '../../../services/utils/schedule.js'
import address from '../../../services/utils/address.js'

export default {
  components: {
    AddressDisplay,
    HighlightChange,
  },
  props: {
    type: String,
    buildingData: Object,
    buildingDataDiff: Object,
  },
  computed: {
    buildingAddressDisplay() {
      if (!this.buildingData.address) return undefined

      return address.format(this.buildingData.address)
    },
    buildingTypeDisplay() {
      switch (this.type) {
        case 'pickup':
          return 'Pickup Building'
        case 'dropoff':
          return 'Dropoff Building'
        default:
          return 'Building'
      }
    },
    buildingAddressDiff() {
      return scheduleUtil.mapDiffObject(this.buildingDataDiff?.address)
    }
  }
}
</script>
